// challenge-feedback-chrome — the teacher challenge-review surface host chrome
// (code-challenge-activity, task 4.2). Mirrors review-chrome.js's Prev/Next
// student navigation and Send Suggestion action; OMITS the submission-state
// pill / Send-Feedback / accept / completed-state UI that assignment review has
// (a Code Challenge has no submit/due-date lifecycle to reflect — the simple
// completion indicator is rendered server-side by the template).
//
//   wire(ctx) — ctx = { core, payload, trinketId, clientsideMode, isOwner, editorApi, doc }
// editor-core is already constructed (editable, re-runnable) and loaded by main.js.

export function wire(ctx) {
  var document = ctx.doc;
  var core = ctx.core;
  var api = ctx.editorApi;
  var body = document.body;

  var submissionId = body.getAttribute('data-submission-id') || '';
  var courseCtx = {
    courseId: body.getAttribute('data-course-id') || '',
    lessonId: body.getAttribute('data-lesson-id') || '',
    materialId: body.getAttribute('data-material-id') || ''
  };
  var returnUrl = body.getAttribute('data-return-url') || '';

  var prevBtn = document.getElementById('challenge-fb-prev');
  var nextBtn = document.getElementById('challenge-fb-next');
  var backBtn = document.getElementById('challenge-fb-back');
  var suggestNoteEl = document.getElementById('challenge-fb-suggest-note');
  var suggestSendBtn = document.getElementById('challenge-fb-suggest-send');
  var suggestStatusEl = document.getElementById('challenge-fb-suggest-status');

  function setStatus(el, text, isError) {
    if (!el) { return; }
    el.textContent = text || '';
    el.classList.toggle('runner-error', !!isError);
  }

  // --- in-page student navigation (same shape as review-chrome.js) --------------
  var ordered = [];
  var idx = -1;

  function dashboardUrl() {
    if (returnUrl) { return returnUrl; }
    return courseCtx.courseId ? ('/library/courses/' + encodeURIComponent(courseCtx.courseId)) : '/library/courses';
  }
  function navTo(sub) {
    if (!sub || !sub.lang || !sub.shortCode) { return; }
    var q = '?courseId=' + encodeURIComponent(courseCtx.courseId) +
      '&lessonId=' + encodeURIComponent(courseCtx.lessonId) +
      '&materialId=' + encodeURIComponent(courseCtx.materialId) +
      '&return=' + encodeURIComponent(returnUrl);
    window.location.href = '/challenge-embed-feedback/' + sub.lang + '/' + sub.shortCode + q;
  }
  if (backBtn) {
    backBtn.addEventListener('click', function () { window.location.href = dashboardUrl(); });
  }

  function disableNav() {
    if (prevBtn) { prevBtn.disabled = true; }
    if (nextBtn) { nextBtn.disabled = true; }
  }
  if (courseCtx.courseId && courseCtx.materialId) {
    api.fetchSubmissions(courseCtx).then(function (list) {
      var rows = Array.isArray(list) ? list : ((list && list.data) || []);
      ordered = rows.filter(function (s) { return s && s.shortCode; });
      idx = ordered.findIndex(function (s) {
        return s.id === submissionId || s.trinketId === submissionId || s.shortCode === submissionId;
      });
      if (prevBtn) {
        prevBtn.disabled = !(idx > 0);
        prevBtn.addEventListener('click', function () { if (idx > 0) { navTo(ordered[idx - 1]); } });
      }
      if (nextBtn) {
        nextBtn.disabled = !(idx >= 0 && idx + 1 < ordered.length);
        nextBtn.addEventListener('click', function () { if (idx >= 0 && idx + 1 < ordered.length) { navTo(ordered[idx + 1]); } });
      }
    }).catch(function (err) { disableNav(); console.error(err); });
  } else {
    disableNav();
  }

  // --- Send suggestion (teacher-code-suggestions) — unchanged, works on any state ---
  if (suggestSendBtn) {
    suggestSendBtn.addEventListener('click', function () {
      suggestSendBtn.disabled = true;
      setStatus(suggestStatusEl, 'Sending…', false);
      api.sendSuggestion(courseCtx, submissionId, core.getFiles(), suggestNoteEl ? suggestNoteEl.value : '')
        .then(function () {
          setStatus(suggestStatusEl, 'Suggestion sent', false);
          if (suggestNoteEl) { suggestNoteEl.value = ''; }
          suggestSendBtn.disabled = false;
        })
        .catch(function (err) {
          setStatus(suggestStatusEl, 'Send failed', true);
          suggestSendBtn.disabled = false;
          console.error(err);
        });
    });
  }
}
